import { Component, OnInit, OnDestroy } from '@angular/core';
import { MemberService } from '@app/services/member.service';
import { SortService } from '@app/components/sorting/SortService';
import { Subscription } from 'rxjs';

interface PhotoMember {
  givenName: string;
  familyName: string;
  homeCity: string;
  id: number;
  institutionName: string;
  institutionShortName: string;
  photoUrl: any;
}

@Component({
  selector: 'app-narvaroregistrering',
  templateUrl: './narvaroregistrering.component.html',
  styleUrls: ['./narvaroregistrering.component.css']
})


export class NarvaroregistreringComponent implements OnInit, OnDestroy {
  memberlist: PhotoMember[] = [];
  imagewidth;
  imageheight;
  imageToShow;
  selectedmembers: any[] = [];
  subscriptions: Subscription[] = [];

  constructor(private memberService: MemberService) { }

  ngOnInit() {
    const searchdata = {
      institutionId: 390
    };
    this.memberService.SearchMemberFromInstitutionByNameOrId(searchdata).subscribe(response => {
      this.memberlist = response;
      this.memberlist.forEach(m => {
        this.getImageFromService(m.id);
      });
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  getImageFromService(memberid: number): any {
    this.subscriptions.push(this.memberService.GetMemberImageThumbnail(memberid).subscribe(data => {
      this.createImageFromBlob(data, memberid);
    }, error => {
      this.imageToShow = null;
    }));
  }

  createImageFromBlob(image: Blob, memberid: number) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageToShow = reader.result;
      this.setPhotoUrl(memberid, this.imageToShow);
      if (this.imageToShow) {
        this.getSize(this.imageToShow);
      }
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
    return this.imageToShow;
  }

  getSize(imgdata) {
    const image = document.createElement('img');
    const self = this;
    image.addEventListener('load', function () {
      self.imagewidth = image.width;
      self.imageheight = image.height;
    });
    image.src = imgdata;
  }

  setPhotoUrl(memberid: number, imagetoshow: any) {
    const idx = this.memberlist.findIndex(item => item.id === memberid);
    this.memberlist[idx].photoUrl = imagetoshow;
  }

  memberSelected(m: any) {
    this.selectedmembers.push(m);
    this.selectedmembers = this.selectedmembers.sort((a, b) => {
      return SortService.cmpStringsWithNumbers(a.familyName, b.familyName, false);
    });
    const idx = this.memberlist.findIndex(element => element.id === m.id);
    this.memberlist.splice(idx, 1);
  }

  unselectMember(m: any) {
    const idx = this.selectedmembers.findIndex(element => element.id === m.id);
    this.selectedmembers.splice(idx, 1);
    this.memberlist.push(m);
    this.memberlist = this.memberlist.sort((a, b) => {
      return SortService.cmpStringsWithNumbers(a.familyName, b.familyName, false);
    });
  }
}
